import { assertInInjectionContext, inject } from '@angular/core';
import { L10n, L10nBase } from './l10n.service';

export const injectTranslation = () => {
  assertInInjectionContext(injectTranslation);
  return (inject(L10n) as L10nBase)._T;
};
